import { createSelector } from 'reselect';

export const featureFlagsSelector = createSelector(
    (state: any) => state.config,
    (config) => config?.featureFlags ?? {}
);